import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { IconX } from '@tabler/icons-react'

const ServiceItem = forwardRef(
  function ServiceItem(props, ref) {
    const [title, setTitle] = useState("");
    const [serviceLink, setServiceLink] = useState("");
    const [isOpen, setIsOpen] = useState("");
    const [errors, setErrors] = useState({});
    const [showDelete, setShowDelete] = useState(false);
    const [description, setDescription] = useState("");
    const [id, setId] = useState(props.data.id);

    useEffect(() => {
      if (props.data) {
        setTitle(props.data.title);
        setDescription(props.data.description);
        setServiceLink(props.data.serviceLink);
      }
    }, [props.data])



    useEffect(() => {
      setIsOpen(props.data.show);
    }, [props.data.show]);

    useEffect(() => {
      setShowDelete(props.showDelete);
    }, [props.showDelete]);

    const validate = () => {
      const errors = {};
      if (!title || (title && title.trim() == "")) {
        errors.title = "Service name is required";
      }
      setErrors(errors);
      return Object.keys(errors).length === 0;
    }

    const getData = () => {
      return {
        id: id,
        title: title,
        description: description,
        serviceLink: serviceLink
      }
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    return (
      <>
        <div className="card accordion-item ">
          <h2 className="accordion-header">
            <button type="button"
              onClick={() => props.showHideService(props.index)}
              className={`accordion-button align-items-center ${isOpen ? "" : "collapsed"}`}>
              {title}
            </button>
          </h2>

          <div className={`accordion-collapse ${isOpen ? "show" : "collapse"}`}>
            <div className="accordion-body mt-3">
              <div className="row">
                <div className="col-lg-6 col-12">
                  <div className="row">
                    <div className="col-md-12 mt-2">
                      <label className="form-label required">
                        Service Name
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.title ? "is-invalid" : ""}`}
                        placeholder="Enter service name"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                      {errors.title && (
                        <div className="invalid-feedback">
                          {errors.title}
                        </div>
                      )}
                    </div>


                    <div className="col-12 mt-4">
                      <label className="form-label">
                        Description (Upto 500 Characters)
                      </label>
                      <textarea
                        style={{ height: "110px", resize: "none" }}
                        className="form-control"
                        placeholder="Enter description"
                        maxLength={500}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="col-md-12 mt-4">
                      <label className="form-label">
                        Service Demo Link
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter demo link"
                        value={serviceLink}
                        onChange={(e) => setServiceLink(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex">
                {showDelete && (
                  <div className=" mt-3">
                    <button type="button" className="btn btn-label-danger"
                      onClick={() => props.deleteService(props.index)}>
                      <IconX className="me-1" size={16} />
                      <span className="align-middle">Delete</span>
                    </button>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>

      </>
    )
  });

export default ServiceItem;
